@if (isLoading) {
	<div class="overlay-new"></div>
}

<div class="flex padding-top-8 gap-horizontal-14 hide-mat-field-subscript">
	<div class="flex flex-fill gap-horizontal-14">
		<mat-form-field appearance="outline" class="dialog w-296">
			<mat-label>{{ 'mes.administration.shift-approval.departments' | translate }}</mat-label>
			<mat-select [(ngModel)]="currentDepartment" (selectionChange)="departmentChange($event)">
				<mat-option [value]="allDepartmentsSelection">
					{{ 'mes.administration.shift-approval.departments-all' | translate }}
				</mat-option>
				@for (department of departments; track department.id) {
					<mat-option [value]="department">{{ department.alias }}</mat-option>
				}
			</mat-select>
		</mat-form-field>
		<mat-form-field appearance="outline" class="dialog w-296">
			<mat-label>
				{{ 'mes.administration.shift-approval.period.label' | translate }}
			</mat-label>
			<mat-date-range-input [formGroup]="range" [rangePicker]="picker">
				<input readonly matStartDate formControlName="start" />
				<input readonly matEndDate formControlName="end" (dateChange)="invalidateStartEndDates()" />
			</mat-date-range-input>
			<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
			<mat-date-range-picker #picker></mat-date-range-picker>
			<div class="hit-layer" (click)="picker.open()"></div>
		</mat-form-field>
		<mat-form-field appearance="outline" class="dialog w-296">
			<input matInput [placeholder]="'insights.administration.users.search' | translate" #input (keyup)="applyFilter($event)" />
			<button mat-icon-button matPrefix>
				<mat-icon svgIcon="acies_search"></mat-icon>
			</button>
		</mat-form-field>
	</div>
	<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems" size="large"></header-sub-menu>
</div>

<div class="table-wrapper">
	<table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
		<ng-container matColumnDef="select">
			<th mat-header-cell *matHeaderCellDef>
				<mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="isAllSelected()" [indeterminate]="isSomeSelected()" [aria-label]="checkboxLabel()"></mat-checkbox>
			</th>
			<td mat-cell *matCellDef="let row">
				<mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)" [disabled]="isDummyShift(row)" [aria-label]="checkboxLabel(row)"></mat-checkbox>
			</td>
		</ng-container>

		<ng-container matColumnDef="expand">
			<th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
			<td mat-cell *matCellDef="let element">
				@if (element.timeStamps[0].worktask) {
					<button mat-icon-button aria-label="expand row" (click)="setExpandedRow(element); $event.stopPropagation()">
						@if (expandedElement === element) {
							<mat-icon>keyboard_arrow_up</mat-icon>
						} @else {
							<mat-icon>keyboard_arrow_down</mat-icon>
						}
					</button>
				}
			</td>
		</ng-container>

		<ng-container matColumnDef="date">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.shift-approval.table.date' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.date | date: 'dd-MM-yyyy' }}</td>
		</ng-container>

		<ng-container matColumnDef="employeeName">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.shift-approval.table.name' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">({{ element.employeeAlias }}) {{ element.employeeName }}</td>
		</ng-container>

		<ng-container matColumnDef="department">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.shift-approval.table.department' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.department }}</td>
		</ng-container>

		<ng-container matColumnDef="teamProfileName">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.shift-approval.table.team' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">({{ element.teamProfileAlias }}) {{ element.teamProfileName }}</td>
		</ng-container>

		<ng-container matColumnDef="rawTime">
			<th mat-header-cell *matHeaderCellDef>
				{{ 'mes.administration.shift-approval.table.raw-time' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.rawStartTime | date: 'H:mm' }} - {{ element.rawEndTime | date: 'H:mm' }}</td>
		</ng-container>

		<ng-container matColumnDef="correctedTime">
			<th mat-header-cell *matHeaderCellDef>
				{{ 'mes.administration.shift-approval.table.norm-time' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">
				<input type="time" step="60" [(ngModel)]="element.correctedStartTime" (blur)="onUpdateCorrectedTimes(element)" (click)="$event.stopPropagation()" [disabled]="!canEditCorrectedTimes(element) || !hasCorrectedTimePermission" />
				<span>-</span>
				<input type="time" step="60" [(ngModel)]="element.correctedEndTime" (blur)="onUpdateCorrectedTimes(element)" (click)="$event.stopPropagation()" [disabled]="!canEditCorrectedTimes(element) || !hasCorrectedTimePermission" />
				@if (shouldShowWorktaskSelector(element)) {
					<app-worktask-select
						[disabled]="!hasWorktaskSelectPermission"
						[value]="selectedWorktask"
						(valueChange)="onSelectedWorktaskChange(element, $event)"
						[worktasks]="sortedTasks"
						valueMode="object"
						[placeholder]="'mes.administration.shift-approval.table.choose-worktask' | translate"
						[filterPlaceholder]="'mes.administration.shift-approval.create-shift-note.worktask.filter-placeholder' | translate"
						(click)="$event.stopPropagation()"></app-worktask-select>
				}
			</td>
		</ng-container>

		<ng-container matColumnDef="payTime">
			<th mat-header-cell *matHeaderCellDef>
				{{ 'mes.administration.shift-approval.table.pay-time' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.payTime }}</td>
		</ng-container>

		<ng-container matColumnDef="overtime">
			<th mat-header-cell *matHeaderCellDef>
				{{ 'mes.administration.shift-approval.table.overtime' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">
				@if (element.overtime !== '0:00') {
					<span class="time-chip-red">{{ element.overtime }}</span>
				}
			</td>
		</ng-container>

		<ng-container matColumnDef="absenceTime">
			<th mat-header-cell *matHeaderCellDef>
				{{ 'mes.administration.shift-approval.table.absence-time' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">
				@if (element.absenceTime !== '0:00') {
					<span class="time-chip-red">{{ element.absenceTime }}</span>
				}
			</td>
		</ng-container>

		<ng-container matColumnDef="note">
			<th mat-header-cell *matHeaderCellDef>
				{{ 'mes.administration.shift-approval.table.note' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">
				<app-employee-note [employeeId]="element.item.employeeId" [date]="element.date"></app-employee-note>
			</td>
		</ng-container>

		<ng-container matColumnDef="approved">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.shift-approval.table.approved' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">
				@if (element.approved) {
					<mat-icon class="margin-left-8 ok-color" svgIcon="acies_true"></mat-icon>
				}
				@if (!element.approved) {
					<mat-icon class="margin-left-8 error-color" svgIcon="acies_false"></mat-icon>
				}
			</td>
		</ng-container>

		<ng-container matColumnDef="status">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.shift-approval.table.status' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">
				<app-shift-status [errors]="element.item.validationErrors" />
			</td>
		</ng-container>

		<ng-container matColumnDef="expandedDetail">
			<td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
				<div class="example-element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
					@if (element === expandedElement) {
						<app-shift-checktime-list [shiftData]="element" [worktasks]="sortedWorktasks"></app-shift-checktime-list>
					}
				</div>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let element; columns: displayedColumns" class="example-element-row" [class.example-expanded-row]="expandedElement === element" [class.hidden]="!showApproved && element.approved" (click)="setExpandedRow(element)"></tr>
		<tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" [class.hidden]="!showApproved && row.approved"></tr>
	</table>
</div>
